//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: [],
    data () {
        return {
            tableData: [],
            pgData: {},

            dialogVisible: false,
            dialogTitle: '',
            trytime: '',
            formSearch: {
                rowguid: ''
            },

            auditForm:{
                auditstatus:"",
                reason:"",
                applyno:"",
                pwd: ""
            },

            auditstatusOption:[
                {value: '0',label: '待审'},
                {value: '1',label: '通过'},
                {value: '2',label: '驳回'},
            ]
        }
    },
    watch: {
        dialogVisible(n, o) {
            !n && this.reloadHandler();
        }
    },
    methods: {
        auditHandler(row) {
            this.dialogTitle = '审核';
            this.auditForm.applyno = row.applyno;
            this.auditForm.pwd = "";
            this.getTryTime();
            this.dialogVisible = true;
        },
        afterSend(){
            this.dialogVisible = false;
        },

        reloadHandler() {
            this.$refs.page.reload();
        },

        getTryTime: function() {
            this.trytime = '';
            this.$get(this.getStore('fy') + '/setting/getvalue?key=sealpw_trytime', (data, res) => {
                this.trytime = data
            });
        },
    },
    mounted: function() {

    }
}
